import React, { Fragment, useState } from 'react';
import { useTranslate, useRecordContext, useListContext, minLength, useNotify, Button,
        SimpleForm, TextInput, } from 'react-admin';
import IconFileCopy from '@mui/icons-material/FileCopy';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import dataProvider from '../dataProvider';
import NoDeleteToolbar from '../../lib/NoDeleteToolbar';

const BookingsheetCopy = (props) => {
  const notify = useNotify();
  const translate = useTranslate();
  const record = useRecordContext();
  const { refetch } = useListContext();

  const [showDialog, setShowDialog] = useState(false);

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };
  
  const doSave = (data) => {
    dataProvider.update('setBookingsheet', { id:record.id, data:data })
      .then(({ data }) => {
        setShowDialog(false);
        refetch();
      })
      .catch(error => {
        notify(error.message, 'error');
      })
  };

  if (!record) return null;
  const prefillTitle = 'Copy of '+record.titel;
  return (
    <Fragment>
      <Button onClick={handleClick} label="glob.copy">
        <IconFileCopy />
      </Button>
      <Dialog fullWidth open={showDialog} onClose={handleCloseClick} aria-label="bw.set.bookingsheet.copytitle" >
        <DialogTitle>{translate("bw.set.bookingsheet.copytitle")}</DialogTitle>
        <DialogContent>
          <SimpleForm onSubmit={doSave} toolbar={<NoDeleteToolbar />} >
            <Fragment>
              <h3>{record.titel}</h3>
              <div>{translate('bw.set.bookingsheet.copyinfo')}</div>
            </Fragment>
            <TextInput source="copyTitle" defaultValue={prefillTitle} validate={minLength(1)} />
          </SimpleForm>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}

export default BookingsheetCopy;
